import Component from './components/StateHistory';

export default Component;
